module.exports = __webpack_public_path__ + "img/icon-emote1.811cd374.svg";